const baseUrl = '/api/customer/post'

export default {
    get: (id) => {
        return axios.get(`${baseUrl}/${id}/comment`)
    },

    store: (postId, message) => {
        return axios.post(`${baseUrl}/${postId}/comment`, {message})
    },
}
